import React, { ReactNode, useCallback, useEffect, useState } from 'react'

import Button from 'components_new/atoms/Button'

import SidebarDialog from 'components_new/molecules/SidebarDialog'

import { useTranslation } from 'language/translator'

type TConfirmAction = 'reject' | 'undo'

interface ConfirmDialogProps {
  action: TConfirmAction
  description?: ReactNode // consequence + reversibility
  onClose: () => void
  onConfirm: (callback: () => void) => void
  open: boolean
  title?: string
}

const ConfirmDialog = (props: ConfirmDialogProps) => {
  const { action, description, onClose, onConfirm, open, title } = props
  const [loading, setLoading] = useState(false)

  const { t } = useTranslation()

  const handleClose = () => {
    setLoading(false)
    onClose()
  }

  const handleConfirm = useCallback(() => {
    setLoading(true)
    onConfirm(() => setLoading(false))
  }, [onConfirm])

  useEffect(() => {
    if (!open) return

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Enter') {
        handleConfirm()
      }
    }

    window.addEventListener('keydown', handleKeyDown)

    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [open, handleConfirm])

  return (
    <SidebarDialog
      actions={
        <>
          <Button variant="text" onClick={handleClose}>
            {t('global', 'cancel')}
          </Button>
          <Button color="primary" loading={loading} onClick={handleConfirm}>
            {t('global', action)}
          </Button>
        </>
      }
      maxWidth="xs"
      open={open}
      onClose={onClose}
      title={`${t('global', action)}${title ? ` ${title}` : ''}?`}
    >
      {description}
    </SidebarDialog>
  )
}

export default ConfirmDialog
